import LocationMap from "./widgets/LocationMap";
import SearchBar from "./widgets/SearchBar";
import Carcategoryslider from "./widgets/Carcategoryslider";
import StationsList from "./widgets/StationList";
import VehicleList from "./widgets/VehicleList";
import ReservationButton from "./widgets/ReservationButton";
import Offers from "./widgets/Offers";
import Tariffs from "./widgets/Tariffs";

function App(props: any) {
  let content;

  switch (props.symbol) {
    case "locationmap":
      content = <LocationMap symbol={props.symbol} />;
      break;
    case "searchbar":
      content = <SearchBar symbol={props.symbol} />;
      break;
    case "carcategoryslider":
      content = (
        <Carcategoryslider
          categorypreselect={props.dataset.categorypreselect}
          usevehicles={props.dataset.usevehicles === "true" ? true : false}
          slidesshown={
            props.dataset.slidesshown
              ? props.dataset.slidesshown.split(",")
              : []
          }
        />
      );
      break;
    case "vehiclelist":
      content = (
        <VehicleList
          special={props.dataset.specialcar}
          showfilter={props.dataset.showfilter === "true" ? true : false}
          categorypreselect={props.dataset.categorypreselect}
          showdetails={props.dataset.showdetails === "true" ? true : false}
          singlecar={props.dataset.singlecar === "true" ? true : false}
          calcprice={props.dataset.calcprice === "true" ? true : false}
          singleimg={props.dataset.singleimg}
          hideFromFilter={
            props.dataset.hidefromfilter
              ? props.dataset.hidefromfilter.split(",")
              : []
          }
        />
      );
      break;
    case "stationlist":
      content = (
        <StationsList
          symbol={props.symbol}
          type={props.dataset.type}
          detailpage={props.dataset.detailpage}
          showfilter={props.dataset.showfilter === "true" ? true : false}
          showdetails={props.dataset.showdetails}
          stationid={props.dataset.stationid}
          geolocation={
            !props.dataset.geolocation
              ? true
              : props.dataset.geolocation === "false"
                ? false
                : true
          }
        />
      );
      break;
    case "reservationbutton":
      content = (
        <ReservationButton
          selectedcargroup={props.dataset.selectedcargroup}
          text={props.dataset.text}
          class={props.dataset.class}
        />
      );
      break;
    case "offers":
      content = (
        <Offers
          symbol={props.symbol}
          claims={props.dataset.claims ? props.dataset.claims.split(",") : ""}
        />
      );
      break;
    case "tarifs":
      //       console.log(props.dataset.tarifs);
      //       console.log(JSON.parse(props.dataset.tariffs));
      // const formattedJson = dataTarifs.replace(/'/g, '"');
      content = (
        <Tariffs
          leadtime={props.dataset.leadtime}
          interval={props.dataset.interval}
          tariffs={JSON.parse(props.dataset.tariffs)}
          showfilter={props.dataset.showfilter === "true" ? true : false}
          stationpreset={props.dataset.stationpreset}
          categorypreselect={props.dataset.categorypreselect}
        />
      );
      break;
    default:
      break;
  }

  return <>{content}</>;
}

export default App;
